export default __webpack_public_path__ + "static/media/sectionTwo1.4c5f8c88.png";